import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  accountPayableObservationCreate,
  accountPayableObservationDelete,
  accountPayableObservationList,
  accountPayableObservationUpdate,
} from './AccountPayableObservation.service';
import { useServiceError } from '@/hooks';
import { AccountInstallmentPayableObservationRequest } from './AccountPayableObservation.types';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';

export function useAccountPayableObservationCreate() {
  const queryChanel = useQueryChanel();

  const mutation = useMutation(accountPayableObservationCreate, {
    onSuccess(_, variables) {
      queryChanel({
        invalidateQueries: [
          ['observation-list'],
          ['observation-list', variables.installmentPayableId],
        ],
      });
    },
  });

  useServiceError(mutation.error);

  return mutation;
}

export function useAccountPayableObservationList(
  obj: AccountInstallmentPayableObservationRequest,
) {
  const query = useQuery(['observation-list', obj.installmentPayableId], () =>
    accountPayableObservationList(obj),
  );

  useServiceError(query.error);

  return query;
}

export function useAccountPayableObservationUpdate() {
  const queryChanel = useQueryChanel();

  const mutation = useMutation(accountPayableObservationUpdate, {
    onSuccess(_, variables) {
      queryChanel({
        invalidateQueries: [
          ['observation-list'],
          ['observation-list', variables.id],
        ],
      });
    },
  });

  useServiceError(mutation.error);

  return mutation;
}

export function useAccountPayableObservationDelete() {
  const queryClient = useQueryClient();

  const mutation = useMutation(accountPayableObservationDelete, {
    onSuccess() {
      queryClient.invalidateQueries(['observation-list']);
    },
  });

  useServiceError(mutation.error);

  return mutation;
}
